export { GlobalTabsManager } from './component';
export type { GlobalTabsManagerProps, NotificationState } from './types';
